import React, { FunctionComponent, useState, useRef } from 'react';
import styles from './NumberOfPosts.module.scss';
import { Popover } from '@material-ui/core';
import { ExclamationIcon } from 'app/assets/images/icons';
import { renderPlatformIcon } from 'app/utils/renderPlatformIcon';
import { v4 as uuid } from 'uuid';
import { nFormatter } from 'app/utils/numbersFormater';
import { makeStyles } from '@material-ui/core/styles';
import { _t } from 'app/utils/i18n';
import AvatarCell from '../AvatarCell';
import { Link } from 'react-router-dom';

interface Props {
  data?: any;
  hideExclamationIcon?: boolean;
  hideText?: boolean;
  isImage?: boolean;
  tableFont?: boolean;
  isLink?: string;
  hideImg?: boolean;
}

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  popoverContent: {
    pointerEvents: 'auto',
  },
  paper: {
    padding: theme.spacing(0),
  },
}));

const NumberOfPosts: FunctionComponent<Props> = ({
  data,
  hideExclamationIcon,
  hideText,
  isImage,
  tableFont,
  isLink,
  hideImg,
}) => {
  const classes = useStyles();
  const [openedPopover, setOpenedPopover] = useState(false);
  const popoverAnchor = useRef(null);

  const popoverEnter = () => {
    setOpenedPopover(true);
  };

  const popoverLeave = () => {
    setOpenedPopover(false);
  };
  if (!data && !data?.length) return <p>-</p>;
  return (
    <div
      className={`${styles.NumberOfPosts} ${data?.[0]?.name}`}
      data-testid="NumberOfPosts-testid"
    >
      {isImage ? (
        <>
          {hideImg ? (
            <AvatarCell hideImg />
          ) : (
            <AvatarCell img={data?.[0]?.image} rounded showEntityImg />
          )}
          <p
            className={`${styles.sourceName} ${
              tableFont ? styles.tableFont : ''
            }`}
          >
            {isLink ? (
              <Link to={`${isLink}/${data?.[0]?.id}`}>{data?.[0]?.name}</Link>
            ) : isLink && data?.[0]?.status === 'TRASHED' ? (
              data?.[0]?.name
            ) : (
              data?.[0]?.name
            )}
          </p>
        </>
      ) : (
        <i>{renderPlatformIcon(data?.[0]?.name, true)}</i>
      )}

      {!hideExclamationIcon && data?.length > 1 && (
        <div className={styles.mainContainer}>
          <i
            ref={popoverAnchor}
            aria-owns={'mouse-over-popover'}
            aria-haspopup="true"
            onMouseEnter={popoverEnter}
            onMouseLeave={popoverLeave}
            data-testid="exclamation-icon"
          >
            <ExclamationIcon />
          </i>
          <div className="popper">
            <Popover
              id="mouse-over-popover"
              className={classes.popover}
              classes={{
                paper: classes.popoverContent,
              }}
              open={openedPopover}
              anchorEl={popoverAnchor.current}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                onMouseEnter: popoverEnter,
                onMouseLeave: popoverLeave,
              }}
              disableRestoreFocus
            >
              <div className={styles.popper}>
                {data?.map((item: any) => {
                  return (
                    <div
                      key={uuid()}
                      className={`${styles.popperItem} ${item?.name}`}
                      data-testid="n-of-posts-popper-item"
                    >
                      {isImage ? (
                        <>
                          {hideImg ? (
                            <AvatarCell hideImg />
                          ) : (
                            <AvatarCell
                              img={item?.image}
                              rounded
                              showEntityImg
                            />
                          )}
                          {!hideText && (
                            <p>
                              {isLink ? (
                                <Link to={`${isLink}/${item?.id}`}>
                                  {item?.name}
                                </Link>
                              ) : isLink && item?.status === 'TRASHED' ? (
                                item?.name
                              ) : (
                                item?.name
                              )}
                            </p>
                          )}
                        </>
                      ) : (
                        <>
                          <span className={styles.icons}>
                            {renderPlatformIcon(item?.name, true)}
                          </span>
                          {!hideText && (
                            <p>
                              {_t('basic:Number_of_Mentions')}
                              {nFormatter(item?.mentions)}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </Popover>
          </div>
        </div>
      )}
    </div>
  );
};

export default NumberOfPosts;
